module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAQCAYAAAAMJL+VAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AUUEg8X1uIQjAAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAAAp0lEQVQ4y+3TMWoCURAG4G/dkAhWD2KT8h0g97CwC9rmEJZCThIM6QQLG7EJ5AI5wysFsdhmCYggNhaysNUrBPFvv4FhZhjuufkUEGN8xjuG2OEbPyml/1wvYow9fOHtonGNCT7xlONlCGGEaWOyR/SxxWuOP2DQsr4XjHHM8Q7WLQUbzHO9gyUWDawxwyrXy6qqDiGE3/P1u/jDB5YppX2u3x/1+jkBI9Ja5w5Bc5cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/red_en_proyecto.png
// module id = kp/9
// module chunks = 0